exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-list__tile__sub-title[data-v-2d4d570f]{font-size:8px}", ""]);

// exports
